import config from 'config';
import axios from 'axios';
import urlUtil from './url';
import backendConfig from './backendConfig';
import backend from './backend';

let fetched = false;
let instanceConfig = {};
let loadingPromise = null;

const get = function() {
  if (fetched) {
    return Promise.resolve(instanceConfig);
  }

  if (loadingPromise) {
    return loadingPromise;
  }

  const sso = window.ssoString;

  if (!sso) {
    return Promise.reject();
  }

  loadingPromise = new Promise((resolve, reject) => {
    return backendConfig.get().then(({backendUrl}) => {
      let url = `${backendUrl}${config.backend.feeds.instanceConfig}?sso=${sso}`;
      url = urlUtil.randomize(url);
      axios
        .get(url)
        .then(resp => {
          if (typeof resp.data !== 'object') {
            window.router.push('error');
            reject();
          }
          instanceConfig = resp.data;
          resolve(instanceConfig);
          fetched = true;
          loadingPromise = false;
        })
        .catch((error) => {
          const resp = error.response;
          resp.body = resp.data;
          if (backend.ssoIsInvalid(resp)) {
            backend.redirectToAnonymousAuth();
            reject();
            return;
          }
          window.router.push('error');
          reject();
          loadingPromise = false;
        })
        // Edge has some problem with finally
        // .finally(() => {
        //   loadingPromise = false;
        // })
        ;
      });
  });

  return loadingPromise;
};

function loadLogoList() {
  return get().then(instanceConfig => {
    return axios
      .get(urlUtil.randomize(instanceConfig['footer-logo-list-url']))
      .then(response => response.data || []);
  });
}

function loadUrls() {
  return new Promise((resolve, reject) => {
    return get().then(instanceConfig => {
      if (!instanceConfig.urls) {
        resolve({})
      }
      resolve(instanceConfig.urls);
    });
  });
}

export default {
  get,
  loadLogoList,
  loadUrls,
};



// WEBPACK FOOTER //
// ./src/utils/instanceConfig.js